export const FR = {
  authentication: {
    title_no_account_yet: "Pas encore de compte ?",
    title_already_an_account: "Déjà un compte ?",

    btn_title_create_account: "Créer un compte",
    btn_title_signin: "Connectez-vous",
    btn_signin_with_google: "Connexion avec Google",
    btn_register_with_google: "Inscription avec Google",
    btn_signin: "Connexion",
    btn_create_account: "Créer mon compte",
    btn_send_link: "Envoyer un lien",
    btn_reset_password: "Réinitialiser le mot de passe",

    text_or_signin_with_email: "Ou connectez-vous avec votre email",
    text_or_register_with_email: "Ou inscrivez-vous avec votre email",
    text_password_resetted: "Votre mot de passe a été réinitialisé.",
    text_ask_email_password_reset_link: "Demander un lien de réinitialisation du mot de passe",
    text_link_sent: "Si l'adresse indiquée existe dans notre base de données, vous allez recevoir un email avec un lien qui vous permettra de réinitialiser votre mot de passe.",
    text_reset_password: "Réinitialisation du mot de passe",
    text_invalid_link: "Invalid or expired link",
    text_email_verified: "Adresse email vérifiée.",
    text_email_recovered: "Adresse email récupérée.",

    link_password_forgotten: "Mot de passe oublié ?",
    link_signin: "Connexion",
    link_create_account: "Créer un compte",

    placeholder_email: "Adresse email",
    placeholder_password: "Mot de passe",
    placeholder_password_confirmation: "Confirmation",

    error_email_password_invalid: "Adresse email et/ou mot de passe incorrect(s).",
    error_while_signin: "Une erreur s'est produite lors de la connexion. Veuillez vérifier votre adresse email et votre mot de passe, puis ré-essayez.",
    error_missing_email: "Veuillez indiquer votre adresse email.",
    error_invalid_email: "Veuillez indiquer une adresse email valide.",
    error_password_confirmation_must_match: "Le mot de passe et sa confirmation doivent correspondre.",
    error_password_invalid: "Votre mot de passe doit contenir au moins 8 caractères et au moins un chiffre.",
    error_account_already_exists: "Un compte avec cette adresse email existe déjà."
  }
};
